import React from 'react';
import './TopBarActions.css';

type TopBarActionIcon = 'account' | 'close';

export interface TopBarAction {
  icon: TopBarActionIcon;
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

interface TopBarActionsProps {
  actions: TopBarAction[];
  className?: string;
  navLabel?: string;
  variant?: 'default' | 'inverse' | 'muted';
}

const TopBarIcon: React.FC<{ icon: TopBarActionIcon }> = ({ icon }) => {
  if (icon === 'close') {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="top-bar-actions__icon"
        aria-hidden="true"
      >
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="top-bar-actions__icon feather feather-settings"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="3"></circle>
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
    </svg>
  );
};

export const TopBarActions: React.FC<TopBarActionsProps> = ({
  actions,
  className,
  navLabel = 'Top bar actions',
  variant = 'default',
}) => {
  const classes = ['top-bar-actions', `top-bar-actions--${variant}`, className]
    .filter(Boolean)
    .join(' ');

  return (
    <nav className={classes} aria-label={navLabel}>
      {actions.map(({ icon, label, onClick, disabled }) => (
        <button
          key={`${icon}-${label}`}
          type="button"
          className="top-bar-actions__button"
          onClick={onClick}
          aria-label={label}
          disabled={disabled}
        >
          <TopBarIcon icon={icon} />
        </button>
      ))}
    </nav>
  );
};
